// prettier-ignore
export default {
  "generic": {
    "network_error": "Nu a fost posibilă conectarea.<br>Vă rugăm să verificați conexiunea la internet.",
    "network_restored": "Conexiunea la internet a fost restabilită",
    "bluetooth_error": "Conexiunea Bluetooth este pierdută.<br>Vă rugăm să vă țineți dispozitivul aproape și să vă asigurați că semnalul este suficient de puternic în timpul procesului de scanare.",
    "permisson_device_orientation_not_allowed": "Pentru a utiliza funcția senzorului direcțional, vă sugerăm să reporniți browserul pentru a reautoriza permisiunea. Sau asigurați-vă că telefonul este aliniat vertical cu solul înainte de a face clic pe Următorul.",
    "permisson_device_orientation_not_support": "Ne pare rău, browserul dvs. nu acceptă funcția senzorului direcțional. Vă recomandăm să încercați un alt browser sau dispozitiv. Sau asigurați-vă că telefonul este aliniat vertical cu solul înainte de a face clic pe Următorul."
  },
  "login": {
    "cloudzet_welcome": "Bună ziua, bine ați venit la Cloudzet",
    "mtm_username": "Cont Scanatic™",
    "password": "Parolă",
    "login": "Conectați-vă",
    "logging_in": "Conectarea...",
    "no_login_methods": "Nu există metode de conectare stabilite pentru acest cont Scanatic™",
    "agreements_button": "Sunteți de acord și continuați",
    "complete_email_reset_pwd_title": "Noi vă susținem!",
    "sent_email": "Am trimis un e-mail către",
    "email_reset_pwd": "Vă rugăm să urmați instrucțiunile pentru a reseta parola",
    "get_the_code": "Nu primiți codul?",
    "resend": "Trimite din nou",
    "complete_phone_reset_pwd_title": "Felicitări!",
    "login_new_password": "Noua parolă a fost setată,<br />vă rugăm să vă conectați cu noua parolă",
    "login_my_account": "Conectați-vă la contul meu",
    "sent_a_code": "Tocmai am trimis un cod către",
    "received_code": "Anunță-mă dacă l-ai primit",
    "verification_code_error": "Eroare de cod de verificare",
    "continue": "Continuați",
    "forget_your_password": "Ați uitat parola?",
    "forget_password_text": "Nu vă faceți griji!",
    "send": "Trimiteți",
    "submit": "Trimite",
    "no_such_user": "Contul nu a fost găsit",
    "email_prompt_text": "Vă vom trimite un e-mail pentru a vă reseta parola",
    "phone_prompt_text": "Vă vom trimite un cod de verificare din 4 cifre",
    "login_title": "Bine ați revenit!",
    "login_email_title": "Conectați-vă cu e-mail",
    "login_phone_title": "Conectați-vă cu telefonul",
    "forget_password": "Ați uitat parola?",
    "terms_of_service": "Termenii noștri de serviciu",
    "choose_a_country_code": "Alegeți un cod de țară",
    "choose_a_country_code_hint": "Conectarea/înregistrarea este disponibilă numai în următoarele țări și regiuni.",
    "country_code_not_found": "Nu ați putut găsi codul țării dvs.?",
    "sign_up_email": "Înregistrați-vă cu e-mail",
    "email_sign_up_error_msg": "Introduceți un e-mail valid",
    "four_characters": "Parola trebuie să aibă min. 4 caractere",
    "try_to_login": "Acest cont există deja. Încercați să vă conectați",
    "try_use_email": "Încercați să utilizați e-mailul dvs.",
    "sign_up": "Înregistrați-vă",
    "sent_verification_code": "Vă vom trimite un cod de verificare din 4 cifre.",
    "sign_up_phone": "Înregistrați-vă cu telefonul",
    "sign_up_store": "Înregistrați-vă cu magazinul",
    "set_up_new_pwd": "Acum, configurați o parolă nouă",
    "set_up_new_password": "Acum, vă puteți configura<br> noua parolă",
    "set_new_pwd": "Setați o parolă nouă",
    "enter_country_code": "Introduceți codul țării",
    "enter_email_address": "Introduceți e-mailul",
    "enter_phone_number": "Număr de telefon",
    "customer_account_name": "Numele contului clientului",
    "enter_password": "Introduceți parola",
    "re_enter_password": "Introduceți din nou parola",
    "login_social_accounts": "Înregistrați-vă cu contul social",
    "social_login_failed": "A eșuat conectarea cu contul social",
    "login_first": "Vă rugăm să vă autentificați mai întâi",
    "create_with_store": "Creați cu magazin",
    "verify": "Verificare",
    "welcome_to_store": "Bine ați venit la {storeName}!",
    "login_to_continue": "Autentificare/ Înscriere pentru a continua",
    "wrong_password": "Parolă incorectă. Vă rugăm să introduceți din nou.",
    "get_the_email": "Nu ați primit e-mailul?"
  },
  "welcome": {
    "enable_bt": "Vă rugăm să activați bluetooth înainte de a continua",
    "welcome_title": "Bine ați venit la<br> Camera de scanare 3D",
    "powered_by": "Powered by TG3D Studio Inc.",
    "tap_to_start": "Atingeți bula pentru a începe",
    "tap_camera_on": "Porniți camera pentru a scana codul QR",
    "ready_to_scan_qr": "Gata pentru scanarea codului QR",
    "note_front_camera": "Vă rugăm să rețineți că camera frontală va fi utilizată la scanarea codului QR",
    "scan_code_title": "Scanați codul QR pentru a începe",
    "scan_code_hint": "Vă rugăm să introduceți codul QR în căsuță",
    "scan_code_processing": "Procesare...",
    "scan_code_logging_in": "Conectarea la contul dvs....",
    "scan_code_connect_to_scanner": "Conectarea la scaner...",
    "scan_code_no_account": "Contul nu există. Vă rugăm să încercați din nou.",
    "scan_code_done": "Gata de plecare!",
    "no_scanner_id": "Nu există niciun ID de scaner configurat pentru acest cont Scanatic™",
    "no_scanner_found": "Scanerul specificat nu a fost găsit",
    "scanner_in_use": "Scanerul este utilizat",
    "unexpected_error": "Ceva nu a mers bine :( <br>Vă rugăm să încercați din nou.",
    "need_camera_permission": "Trebuie să acordați camerei permisiunea de a utiliza această funcție",
    "share_qr_code": "Afișați codul meu QR",
    "my_qr_code": "Codul meu QR",
    "scan_qr_code_reminder": "Veți fi conectat la alte dispozitive atunci când scanați codul QR."
  },
  "choose": {
    "step_name": "Pregătiți-vă pentru scanarea corporală 3D",
    "step_info": "Când ești gata,<br>mișcă-ți pumnii în bule",
    "tutorial": "Tutorial",
    "start_scan": "Scanare 3D",
    "clench_fingers": "Strângeți ușor degetele",
    "raise_arm": "Mișcați brațul până atingeți bula",
    "hold_til_fill": "Acum țineți până când bula este umplută"
  },
  "thingstonote": {
    "title": "Înainte de scanarea corporală 3D",
    "wear_tight": "Purtați haine strâmte și mulate",
    "tie_hair": "Leagă-ți părul pentru a-ți arăta ceafa",
    "remove_acc": "Scoateți toate accesoriile"
  },
  "scanscreen": {
    "skip": "Salt"
  },
  "tutorial": {
    "title": "Tutorial de control fără contact",
    "contactless": "Experiența fără contact asigură protecția sănătății dumneavoastră",
    "clench_fingers": "Strângeți ușor degetele",
    "raise_arm": "Pentru a controla bulele, vă rugăm să vă mișcați brațele până când atingeți bulele și țineți timp de 2 secunde",
    "hold": "Acum țineți până când bula este umplută",
    "proceed": "Pentru a trece la pasul următor, mișcați brațul drept până când atinge bula.",
    "return": "Pentru a reveni la pasul anterior, mișcați brațul stâng până când atinge bula.",
    "feet_pos": "Poziționați-vă picioarele pe covorul de podea"
  },
  "scan": {
    "feet_pos": "Poziționați-vă picioarele pe covorul de podea",
    "step_name": "Scanare corporală 3D",
    "phase_one_done": "Faza 1 finalizată",
    "begin_2nd": "Începeți scanarea corpului în poziția a 2-a",
    "clench": "Strângeți ușor degetele",
    "raise_both_arm": "Mișcați brațele încet și țineți-vă pumnii în bule",
    "raise_fists": "Mișcă-ți pumnii spre exterior, spre zona cu bule",
    "lower_fists": "Mișcă-ți pumnii spre interior în zona bulei",
    "hold_still": "Ține-ți brațele nemișcate",
    "scan_keep_still": "Păstrați-vă corpul nemișcat",
    "scan_in_progress": "Scanare în curs",
    "scan_complete": "Scanare finalizată. <br> Vă puteți relaxa corpul.",
    "two_step_scan": "Scanarea va fi efectuată în 2 etape",
    "raise_elbow": "Ridicați coatele spre exterior pentru a evita ca brațele să atingă corpul în timpul scanării",
    "scanner_occupied": "Camera de scanare este ocupată.  Vă rugăm să contactați personalul pentru a reseta scanerul și a încerca din nou.",
    "scanner_error_need_reset": "Eroare de scaner.  Vă rugăm să contactați personalul pentru a reseta scanerul și a încerca din nou.",
    "scanner_error_generic": "Eroare scanner.  Vă rugăm să contactați personalul.",
    "scanner_not_activated": "Scannerul nu este activat.  Vă rugăm să contactați personalul.",
    "scanner_check_network": "Vă rugăm să contactați personalul pentru a verifica dacă scanerul este conectat la internet sau să resetați scanerul și să încercați din nou."
  },
  "handles": {
    "hold": "Țineți mânerele.<br>Arme relaxate și îndreptate",
    "hold_ready": "Țineți mânerele.<br>Acum sunteți gata",
    "letgo_and_keep_feet": "Dați drumul la mânere și țineți picioarele pe podea.",
    "clench_ipose": "Pumnii ușor strânși, mâinile la aproximativ 5 cm (2 inci) distanță de corp",
    "clench_ready": "Pumnii ușor încleștați, Sunteți gata acum"
  },
  "end": {
    "thank": "Vă mulțumim!",
    "belonging": "Vă rugăm să nu uitați să aveți asupra dumneavoastră obiectele personale."
  },
  "analyzing": {
    "check_err": "Crearea unui avatar 3D..."
  },
  "result": {
    "scan_successful": "Bună treabă!<br>Scanarea dvs. 3D a avut succes",
    "scan_unsuccessful": "Nu putem prelucra datele dumneavoastră",
    "avoid_errors": "Cauze comune ale erorilor de scanare",
    "error_accessories": "Accesorii de purtat",
    "error_cover_neck": "Părul vă acoperă gâtul",
    "error_floor_marks": "Picioarele în poziție greșită",
    "error_postural": "Postură incorectă",
    "leave": "Plecați",
    "raise": "Mută-ți pumnii în bule pentru a scana din nou",
    "scan_again": "Scanați din nou",
    "analyzing": "Procesarea datelor de scanare...",
    "click_scan_again": "Faceți clic pe butonul de mai jos pentru a scana din nou",
    "oops": "Oops!",
    "unexpected_error": "Ceva pare în neregulă...",
    "close": "Închidere",
    "error_top_loose": "Bluza este prea largă",
    "error_bottoms_loose": "Pantalonii sunt prea largi",
    "error_outfit_loose": "Ținuta este prea largă",
    "scan_error_detected": "Probleme detectate la scanare"
  },
  "measurement": {
    "neck": "Gât",
    "chest": "Piept",
    "torso": "Trunchi",
    "mid_waist": "Talie medie",
    "hip": "Anca",
    "shoulder": "Umăr",
    "biceps": "Biceps",
    "arm": "Braț",
    "thigh": "Coapsă",
    "inner_leg": "Picior interior",
    "chest_female": "Circumferința bustului"
  },
  "homePage": {
    "firstScanTitle": "Începeți-vă<br/>călătoria spre viitor",
    "tap_to_scan": "Atingeți pentru scanare 3D",
    "measurement": "Măsurarea",
    "body_3d_avatar": "Corp 3D",
    "see_more": "A se vedea mai mult",
    "menu": "Meniu",
    "store_settings": "Setări magazin",
    "avatar_shader_3d": "Shader Avatar 3D",
    "avatar_shader": "Shader avatar",
    "create_3d_shader": "Crearea unui Shader 3D",
    "language": "Limba",
    "get_help": "Obțineți ajutor",
    "feedback": "Feedback",
    "send_feedback": "Trimiteți feedback",
    "send_btn": "Trimiteți",
    "send_feedback_placeholder": "Feedback-ul dvs. ne va ajuta să ne îmbunătățim produsul și serviciul",
    "send_feedback_title": "Vă mulțumim pentru feedback",
    "send_feedback_content": "Vom lua notă de feedback-ul dvs. și sperăm să oferim o experiență mai bună în viitor. Vă rugăm să nu ezitați să ne contactați dacă aveți mai multe de spus!",
    "report_crash": "Raportați un accident",
    "report_crash_title": "Vă mulțumim pentru că ne-ați anunțat",
    "report_crash_content": "Ne pare rău pentru experiența dumneavoastră. <br>Echipa noastră va inspecta această problemă cât mai curând posibil. În același timp, vă rugăm să nu ezitați să ne contactați dacă întâmpinați alte probleme.",
    "rate_app": "Îmi place aplicația Cloudzet",
    "rate_app_title": "Evaluați Cloudzet App",
    "rate_app_content": "Dacă vă place aplicația noastră, vă rugăm să ne acordați un moment pentru a o evalua sau recenza în App Store. Vă mulțumim!",
    "login_s4f": "Conectați-vă cu contul <br/> Scanatic™",
    "login": "Autentificare",
    "password": "Parolă",
    "account_settings": "Setări cont",
    "enter_Scanatic_account": "Introduceți contul Scanatic™",
    "logout": "Deconectați-vă",
    "delete_account": "Ștergeți contul",
    "confirm_delete": "Sunteți sigur?",
    "contactless_scan": "Scanare fără contact",
    "delete": "Ștergeți",
    "cancel_delete": "Anulează",
    "ok": "Bine",
    "scan_to_login": "Scanați codul QR",
    "history": "Istoric",
    "view_avatar": "Vizualizați avatarul 3D",
    "select_date": "Selectați data",
    "select": "Selectați",
    "analysis": "Analiză",
    "comparison": "Comparație",
    "leftCompareView": "Model stânga",
    "rightCompareView": "Model drept",
    "go_to_app_store": "Mergeți la App Store",
    "measure": "Măsură",
    "history_tab": "Istoric"
  },
  "settingUserData": {
    "your_birth": "Spune-mi anul nașterii tale?",
    "your_gender": "Spune-mi sexul tău",
    "female": "Femei",
    "male": "Masculin",
    "tall": "Cât de înalt ești?",
    "cm": "cm",
    "ft": "ft",
    "inch": "inch",
    "your_height": "Înălțime",
    "your_weight": "Cât de mult cântărești?",
    "weight": "Greutate",
    "lbs": "lbs",
    "kg": "kg",
    "nickname": "Numele dvs.",
    "metric": "cm/kg",
    "imperial": "ft/lbs",
    "lets_go": "Să începem"
  },
  "profile": {
    "profile": "Profil",
    "edit_profile": "Editare profil",
    "name": "Nume și prenume",
    "birthday": "Ziua de naștere",
    "birthyear": "Anul nașterii",
    "phone": "Număr de telefon",
    "email": "E-mail",
    "address": "Adresă",
    "save": "Bine",
    "file_size_exceed": "Dimensiunea fișierului nu poate depăși 1MB"
  },
  "discover": {
    "head_title": "Descoperiți",
    "check_my_size": "Verifică mărimea mea",
    "rmd_size": "Dimensiune recomandată",
    "no_rmd_data": "Nu există dimensiuni recomandate pentru acest articol",
    "no_rmd_items": "Oops! Nu a fost găsit niciun element recomandat",
    "buy_item": "Cumpărați"
  },
  "discovery": {
    "turn_on_bt": "Porniți Bluetooth",
    "turn_on_bt_hint": "Autorizarea și activarea Bluetooth",
    "turn_on_bt_hint_ios": "Vă rugăm să vă asigurați că următoarele setări sunt finalizate:<br>1. Acordați permisiunea<br> ● Mergeți la Setări > Confidențialitate și securitate > Bluetooth și activați accesul pentru Cloudzet.<br>2. Activați Bluetooth<br> ● Mergeți la Setări > Bluetooth și activați-l.",
    "turn_on_bt_hint_android": "Vă rugăm să vă asigurați că următoarele setări sunt finalizate:<br>1. Activați Bluetooth<br> ● Glisați în jos din partea de sus a ecranului, apoi atingeți Bluetooth.",
    "searching": "Căutarea dispozitivelor din apropiere...",
    "select_scanner": "Selectați un dispozitiv de scanare din apropiere pentru a începe",
    "scanner__foot": "Scaner pentru picioare",
    "scanner__body": "Scaner corporal",
    "start_scan": "Începeți scanarea 3D",
    "no_scanners": "Nu pot găsi niciun scaner în apropiere",
    "try_again": "Încercați din nou",
    "scanner_is_busy_title": "Scannerul este ocupat",
    "scanner_is_busy_desc": "Vă rugăm să verificați dacă este cineva înăuntru folosind scanerul.",
    "scanner_is_busy_force_release": "Scanați acum",
    "scanner_is_busy_wait": "Așteptați scanarea"
  },
  "footscan": {
    "take_off": "Înainte de scanarea 3D<br>vă rugăm să vă scoateți pantofii",
    "barefoot": "Purtați șosete strânse<br>sau mergeți desculți",
    "show_ankles": "Ridicați picioarele pantalonilor<br>pentru a vă descoperi gleznele",
    "sit": "Vă rugăm să vă așezați cu genunchii îndoiți la un unghi de 90",
    "stand_up": "Vă rugăm să vă ridicați",
    "position_feet": "Poziționați-vă picioarele pe<br>zona marcată pe podea",
    "start_scan": "Gata de scanare",
    "ready_to_scan": "Gata de plecare!",
    "stand_up_for_2nd_scan": "Vă rugăm să stați în picioare și cu fața dreaptă pentru a vă pregăti pentru scanare",
    "stand_still": "Vă rugăm să vă mențineți corpul nemișcat<br>și cu fața înainte",
    "scan_complete": "Scanare finalizată<br>Vă puteți relaxa",
    "creating_3d_foot": "Crearea modelului 3D al piciorului...",
    "scan_successful": "Bună treabă!<br>Scanarea dvs. 3D a avut succes",
    "click_to_rescan": "Faceți clic pe butonul de mai jos<br>pentru a scana din nou",
    "feet_3d": "Picioare 3D",
    "analysis": "Analiza piciorului",
    "initial_l": "L",
    "initial_r": "R",
    "tab__fit": "Pantofi potriviți",
    "tab__width": "Lățime",
    "tab__arches": "Arce",
    "tab__measure": "Măsură",
    "tab__type": "Tip",
    "shoes_guide": "Ghid de mărime pentru pantofi",
    "shoes_last": "Ultima ta încălțăminte",
    "measurement__ball": "Circumferința mingii",
    "measurement__foot_length": "Lungime",
    "measurement__foot_width": "Lățime",
    "measurement__instep": "Circumferința tălpii piciorului",
    "measurement__span": "Circumferința Span",
    "measurement__arch": "Arce",
    "measurement__finger_shape": "Tip picior",
    "arch_type__title": "Arcada piciorului",
    "arch_type__high": "Arc înalt",
    "arch_type__summary_high": "Arcada unui picior cav va părea înaltă chiar și atunci când stați în picioare. În plus, pot fi prezente unul sau mai multe dintre următoarele simptome.",
    "arch_type__desc_high": "• Degete în ciocan (degete îndoite) sau degete în gheară.<br> • Calusuri pe bila, partea laterală sau călcâiul piciorului.<br> • Durere în picioare sau la mers.<br> • Un picior instabil din cauza înclinării călcâiului spre interior, care poate duce la entorse de gleznă.",
    "arch_type__normal": "Arc normal",
    "arch_type__summary_normal": "Dacă partea de mijloc a arcadei dvs. este umplută aproximativ pe jumătate, înseamnă că aveți o arcadă normală.",
    "arch_type__desc_normal": "• Degete în ciocan (degete îndoite) sau degete în gheară.<br> • Calusuri pe bila, partea laterală sau călcâiul piciorului.<br> • Durere în picioare sau la mers.<br> • Un picior instabil din cauza înclinării călcâiului spre interior, care poate duce la entorse de gleznă.",
    "arch_type__low": "Boltă joasă",
    "arch_type__summary_low": "Pronația este un termen utilizat pentru a descrie mișcarea de înclinare spre interior a piciorului și a oaselor gleznei spre arcadă.",
    "arch_type__desc_low": "• Degete în ciocan (degete îndoite) sau degete în gheară.<br> • Calusuri pe bila, partea laterală sau călcâiul piciorului.<br> • Durere în picioare sau la mers.<br> • Un picior instabil din cauza înclinării călcâiului spre interior, care poate duce la entorse de gleznă.",
    "foot_type__title": "Tipul dvs. de picior",
    "foot_type__egyptian": "Deget egiptean",
    "foot_type__summary_egyptian": "Degetele scad în lungime de la degetul mare la degetul mic.",
    "foot_type__desc_egyptian": "Picioarele majorității bărbaților asiatici au degetele mari lungi și oasele degetelor înclinate.<br> Purtarea pantofilor este ușoară pentru a strânge degetul mare. Cel mai bine este să alegeți pantofi cu o greutate ușor înclinată a degetului.<br>Cea mai mare parte a cantității cade pe degetul mare, este ușor să întoarceți degetele, nu este potrivit pentru pantofi ascuțiți.",
    "foot_type__roman": "Roman Toe",
    "foot_type__summary_roman": "Primele 3 degete sunt de aceeași lungime, în timp ce celelalte două sunt mai scurte.",
    "foot_type__desc_roman": "Această formă specială de deget se caracterizează prin faptul că primele trei degete au aceeași înălțime, iar celelalte două sunt în ordine descrescătoare. Persoanele care au acest tip de deget sunt cunoscute ca având o formă echilibrată a corpului, precum și o personalitate echilibrată.",
    "foot_type__greek": "Deget grecesc",
    "foot_type__summary_greek": "Al doilea deget de la picior este mai proeminent decât restul, inclusiv degetul mare.",
    "foot_type__desc_greek": "Mușchii celui de-al doilea deget de la picior, astfel încât mușchii celui de-al doilea deget de la picior se ciocnesc cu degetul de la picior, iar frecarea va provoca dureri ale degetului de la picior. Se recomandă utilizarea pantofilor cu vârf rotund, a pantofilor cu vârf oblic și a pantofilor care nu calcă pe degetele de la picioare.",
    "foot_type__unknown": "Necunoscut",
    "foot_type__summary_unknown": "Rezumat necunoscut",
    "foot_type__desc_unknown": "Desc Necunoscut"
  },
  "mobileScan": {
    "mobile_scan": "Scanare mobilă",
    "body_scanner": "Scaner corporal",
    "data_processing": "Procesarea datelor de scanare...",
    "comeback_later": "Vă rugăm să reveniți în 5-10 minute pentru a vă revizui avatarul 3D",
    "data_process_failed": "Imposibilitatea de a procesa datele de scanare",
    "error_not_inscreen": "Întregul dvs. corp nu este capturat pe ecran",
    "error_messy_background": "Fundalul este prea dezordonat",
    "device_unsupported": "Oops!<br>Dispozitivul dvs. nu acceptă scanarea 3D a telefonului mobil",
    "need_faceid": "Scanarea corporală 3D mobilă poate fi utilizată numai pe iPhone X sau pe iPhone-uri mai noi cu Face ID",
    "scanner_name": "Scanare corporală 3D mobilă",
    "confirm_info": "Vă rugăm să confirmați informațiile dvs. personale",
    "begin_title": "Pregătiți-vă pentru scanare",
    "begin_info": "Poartă haine strâmte și leagă-ți părul pentru a-ți arăta ceafa",
    "start_tutorial": "Începeți tutorialul",
    "not_first": "Nu sunteți pentru prima dată aici?",
    "skip_tutorial": "Sari peste tutorial",
    "vertical_info": "Așezați telefonul<br>vertical pe o suprafață<br>plată",
    "inscreen_info": "Asigurați-vă că<br>întregul dvs. corp<br>este capturat",
    "backoff_info": "Faceți clic pe următorul, mergeți înapoi<br>și intrați în poziția de scanare<br>în 10 secunde.",
    "spin_info": "Strângeți degetele,<br> deschideți brațele și rotiți<br>în 360° în 10 secunde.",
    "check_title": "Pregătiți-vă pentru scanare",
    "check_info": "Vă rugăm să confirmați pe<br>următoarea listă de verificare",
    "wear_tight": "Purtați haine mulate pe piele și legați-vă părul",
    "wipe_front": "Curățați lentila camerei frontale",
    "volume_up": "Porniți volumul până la capăt",
    "next": "Următorul",
    "start_scan": "Începeți scanarea",
    "starting_in": "Începând cu",
    "preview_info": "Vă rugăm să confirmați pe<br>următoarea listă de verificare",
    "preview_inscreen": "Întregul corp este capturat",
    "preview_arms_open": "Brațele deschise și degetele încleștate",
    "preview_spin": "Rotire 360°",
    "preview_delete": "Videoclipul va fi șters odată ce avatarul este creat",
    "rescan": "Scanați din nou",
    "uploading": "Procesarea datelor de scanare...<br>Nu închideți fereastra",
    "uploading_done": "Analiză completă!<br>Vă rugăm să reveniți în 5-10 minute pentru a vă revizui avatarul 3D",
    "finish_btn": "Finish",
    "upload_error": "Funcția mobilă de scanare corporală 3D nu este activată<br>Vă rugăm să contactați magazinul selectat pentru mai multe informații",
    "no_balance": "Funcția mobilă de scanare corporală 3D este suspendată<br>Vă rugăm să contactați magazinul selectat pentru mai multe informații",
    "scan_limit_reached": "Ți-ai atins limitele de scanare pentru această lună<br>(fiecare cont de scanare este limitat la 3 scanări pe lună)",
    "leave": "Plecați",
    "no_credits": "Oops!\nNu aveți suficiente credite",
    "no_email": "Oops!\n Trebuie să introduceți\nmai întâi adresa dvs. de e-mail",
    "credits": "Creditele dvs.",
    "purchase": "Cumpărați credit",
    "purchase_cart": "Coșul meu",
    "purchase_total": "Total",
    "purchase_item": "Articolul",
    "purchase_checkout": "Checkout",
    "purchase_reminder": "Vom trimite o factură la adresa dvs. de e-mail.",
    "payment_succeed": "Felicitări!\nComanda dvs. a fost plasată",
    "payment_succeed_des": "Vom trimite un e-mail\npentru a confirma detaliile comenzii dumneavoastră",
    "update_email": "Actualizare e-mail",
    "front_info": "Pentru fotografia din față, mențineți poziția A și stați nemișcat.",
    "side_info": "Pentru fotografia laterală, întoarceți-vă spre stânga. Țineți brațele aproape de corp și stați nemișcat.",
    "qr_not_valid": "Cod QR nevalid",
    "qr_not_valid_desc": "Contactați magazinul pentru un nou cod QR.",
    "back_to_home": "Înapoi la pagina principală"
  },
  "mobileScan2": {
    "inscreen_front_info": "Asigurați-vă că întregul corp este vizibil pe ecran, cu brațele și picioarele ușor depărtate",
    "inscreen_side_info": "Pentru fotografia laterală, vă rugăm să vă întoarceți la stânga. Țineți picioarele împreună și așezați ambele mâini pe partea exterioară a coapselor",
    "inscreen_info": "Asigurați-vă că întregul corp este vizibil pe ecran. Evitați să surprindeți marginea mesei.",
    "trun_left_info": "Întoarceți-vă la stânga, puneți mâinile pe partea exterioară a coapselor, țineți picioarele împreună"
  },
  "share": {
    "voucher_expired": "Sesiunea a expirat.<br>Vă rugăm să reporniți pagina.",
    "no_scan_data": "Nu s-au găsit rezultate ale scanării."
  }
};
